/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AdminPlanStoragePost = {
  id: 'admin-plan-storage.post',
  tag: 'Admin',
  summary: 'Admin Storage plan creation',
  description: 'Create storage plan',
  method: 'post',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/plan/storage`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            storageClassId: z.string(),
            size: z.number().min(1),
            name: z.string().min(1),
            isVisible: z.boolean(),
            serviceType: ZodTypes.ServiceType,
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
